<template>
    <view-experimental-datasets-by-plan-component :activeExperimentalDatasets="activeExperimentalDatasets" :archivedExperimentalDatasets="archivedExperimentalDatasets" @viewExperimentalDataset="handleViewExperimentalDataset" @uploadExperimentalDataset="handleUploadExperimentalDataset" @duplicateExperimentalDataset="handleDuplicateExperimentalDataset" :currentExperimentalPlan="currentExperimentalPlan" @openExperimentalPlan="handleOpenExperimentalPlan"></view-experimental-datasets-by-plan-component>
</template>


<script>
import ViewExperimentalDatasetsByPlanComponent from '@/components/dataset/ViewExperimentalDatasetsByPlanComponent'
import axios from "axios";
import { mapGetters, mapMutations } from 'vuex'

export default {
    name: "ViewExperimentalDatasetsByPlan",
    components: { ViewExperimentalDatasetsByPlanComponent},
    computed: {
        ...mapGetters([
            'base_url', 'currentExperimentalPlanObject', 'auth_header'
        ]),
    },
    data: function() {
        return {
            component_url: 'experiments/datasets',
            activeExperimentalDatasets: [],
            archivedExperimentalDatasets: [],
            currentExperimentalPlan: {},
        }
    },
    methods: {
        ...mapMutations([
            'SET_BREADCRUMB', 'CHANGE_EXPERIMENTAL_PLAN_OBJECT'
        ]),
        setBreadcrumb: function(){
            this.SET_BREADCRUMB(this.$route.meta.breadcrumb)
        },
        setExperimentalPlan: function(){
            this.CHANGE_EXPERIMENTAL_PLAN_OBJECT(this.currentExperimentalPlan)
        },
        getActiveExperimentalDatasets: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.activeExperimentalDatasets = response.data;
                    console.log("Active ExperimentalDataset json: ")
                    console.log(this.activeExperimentalDatasets)
                })
                .catch(error => {
                    console.log("Something went wrong getting the ExperimentalDatasets : ", error.response.data);
                });
        },
        getArchivedExperimentalDatasets: function() {
            axios
                .get(`${this.base_url}${this.component_url}?archived=False`, {
                    headers: this.auth_header
                })
                .then(response => {
                    this.archivedExperimentalDatasets = response.data;
                    console.log("Archived ExperimentalDataset json: ")
                    console.log(this.archivedExperimentalDatasets)
                })
                .catch(error => {
                    console.log("Something went wrong getting the ExperimentalDatasets : ", error.response.data);
                });
        },
        handleOpenExperimentalPlan: function(currentExperimentalPlan){
            this.$router.push({ name: "ViewExperimentalPlan", params: { id: currentExperimentalPlan.id } });
        },
        handleViewExperimentalDataset: function(currentExperimentalDataset) {
            this.$router.push({ name: "ViewAnExperimentalDataset", params: { id: currentExperimentalDataset.id } });
        },
        handleUploadExperimentalDataset: function(currentExperimentalDataset) {
            this.$router.push({ name: "UploadExperimentalDataset", params: { id: currentExperimentalDataset.id } });
        },
        handleDuplicateExperimentalDataset: function(currentExperimentalDataset) {
            this.$router.push({ name: "NewExperimentalDataset", params: { duplicateExperimentalDataset: currentExperimentalDataset } });
        }
    },
    mounted: function(){        
        if(this.$route.params.experimentalPlan){
            this.currentExperimentalPlan = this.$route.params.experimentalPlan
        } else {
            this.currentExperimentalPlan = this.currentExperimentalPlanObject
        }
        console.log("mounting and checking ex plan", this.currentExperimentalPlan)
        this.setExperimentalPlan()
        this.setBreadcrumb()
        this.getActiveExperimentalDatasets()
        this.getArchivedExperimentalDatasets()
    }
}
</script>